module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921031149_T.393cf653.jpg";